import { ISiteNetworkOption } from 'types/siteNetwork.interface'
import {
  OffroadClusterStatus,
  RoadClass,
  RoadEventType,
  SiteNetworkLoadState,
  SiteNetworkMachineClass,
} from 'types/siteNetworkEnums.interface'
import { tokens } from 'styling/tokens'

export const vehicleOptions: ISiteNetworkOption[] = [
  { label: 'Haul truck · loaded', value: `${SiteNetworkMachineClass.HaulTruck}|${SiteNetworkLoadState.Loaded}` },
  { label: 'Haul truck · empty', value: `${SiteNetworkMachineClass.HaulTruck}|${SiteNetworkLoadState.Empty}` },
  { label: 'Light vehicle', value: `${SiteNetworkMachineClass.LightVehicle}|${SiteNetworkLoadState.NA}` },
  { label: 'Crew bus', value: `${SiteNetworkMachineClass.Bus}|${SiteNetworkLoadState.NA}` },
  { label: 'On foot', value: `${SiteNetworkMachineClass.Person}|${SiteNetworkLoadState.NA}` },
  { label: 'Excavator', value: `${SiteNetworkMachineClass.Excavator}|${SiteNetworkLoadState.NA}` },
  { label: 'Grader', value: `${SiteNetworkMachineClass.Grader}|${SiteNetworkLoadState.NA}` },
  { label: 'Wheel loader', value: `${SiteNetworkMachineClass.WheelLoader}|${SiteNetworkLoadState.NA}` },
]

export const roadClassOptions: ISiteNetworkOption[] = [
  { label: 'Haul primary', value: RoadClass.HaulPrimary },
  { label: 'Haul ramp', value: RoadClass.HaulRamp },
  { label: 'Bench access', value: RoadClass.BenchAccess },
  { label: 'Service road', value: RoadClass.ServiceRoad },
  { label: 'LV only', value: RoadClass.LightVehicleOnly },
  { label: 'Pedestrian', value: RoadClass.Pedestrian },
]

export const roadEventTypeOptions: ISiteNetworkOption[] = [
  { label: 'Closed', value: RoadEventType.Closed },
  { label: 'Restricted', value: RoadEventType.Restricted },
  { label: 'Speed limit', value: RoadEventType.SpeedLimit },
  { label: 'Degraded', value: RoadEventType.Degraded },
]

export const machineClassOptions: ISiteNetworkOption[] = [
  { label: 'Haul truck', value: SiteNetworkMachineClass.HaulTruck },
  { label: 'Excavator', value: SiteNetworkMachineClass.Excavator },
  { label: 'Grader', value: SiteNetworkMachineClass.Grader },
  { label: 'Wheel loader', value: SiteNetworkMachineClass.WheelLoader },
  { label: 'Light vehicle', value: SiteNetworkMachineClass.LightVehicle },
  { label: 'Person', value: SiteNetworkMachineClass.Person },
  { label: 'Bus', value: SiteNetworkMachineClass.Bus },
]

export const roadDraftColor = tokens.status.info.fg

export const roadClassColors: { [key: string]: string } = {
  [RoadClass.HaulPrimary]: tokens.status.info.fg,
  [RoadClass.HaulRamp]: tokens.accent.base,
  [RoadClass.BenchAccess]: tokens.status.accent.fg,
  [RoadClass.ServiceRoad]: tokens.text.secondary,
  [RoadClass.LightVehicleOnly]: tokens.status.info.fg,
  [RoadClass.Pedestrian]: tokens.text.muted,
  HAUL_PRIMARY: tokens.status.info.fg,
  HAUL_RAMP: tokens.accent.base,
  BENCH_ACCESS: tokens.status.accent.fg,
  SERVICE_ROAD: tokens.text.secondary,
  LIGHT_VEHICLE_ONLY: tokens.status.info.fg,
  PEDESTRIAN: tokens.text.muted,
}

export const defaultRoadClassColor = tokens.text.secondary

export const roadEventTypeLabel = (type: number | string) => {
  const n = Number(type)
  const found = roadEventTypeOptions.find((o) => Number(o.value) === n)
  if (found) return found.label
  return String(type)
}

export const proposalStatusLabel = (status: number) => {
  if (status === OffroadClusterStatus.Proposed) return 'Proposed'
  if (status === OffroadClusterStatus.Accepted) return 'Accepted'
  if (status === OffroadClusterStatus.Dismissed) return 'Dismissed'
  return String(status)
}

export const machineClassLabel = (value: number) =>
  machineClassOptions.find((o) => Number(o.value) === value)?.label || String(value)
